import * as React from "react";
import "./styles.scss";
import { NewCensusProcess } from "../NewCensusProcess";
import { ProcessPage } from "../../../../Processes";
import { AnimationProvider } from "../../providers/AnimationProvider";
import { CensusCoolerContext } from "../../providers/CensusCollerProvider";
import { Display } from "../../../../../components/Display";
import { Loader } from "../../../../../components/Utils/loader/Loader";
import { getErrorMessage } from "./utils";
import { VeBoxCard } from "../../../../../components/card/VeBoxCard";
import { FormCardFooter } from "../../../../common";
import { RestApiError } from "../../data/models/RestApi";

type MainPageProps = {};

export const MainPage: React.FC<MainPageProps> = () => {
	const { isLoading, error, AppTranslations, censusAvailability } =
		React.useContext(CensusCoolerContext);

	const [errorState, setErrorState] = React.useState<Error | RestApiError>();
	const [isLoadingPage, setIsLoadingPage] = React.useState<boolean>(true);

	const goBackHome = () => {
		window.location.reload();
	};

	React.useEffect(() => {
		if (error || censusAvailability?.error) {
			setErrorState(error ?? censusAvailability?.error);
		}
		setIsLoadingPage(isLoading || censusAvailability?.isLoading);
	}, [
		isLoading,
		error,
		censusAvailability?.isLoading,
		censusAvailability?.error,
	]);

	return (
		<>
			<Display isVisible={isLoadingPage}>
				<div className={"main-loader-container"}>
					<Loader relativelyCentered={true} />
				</div>
			</Display>
			<Display isVisible={errorState}>
				<div className={"census-cooler"}>
					<VeBoxCard className={"error-card"}>
						{getErrorMessage(errorState, AppTranslations)}
						<FormCardFooter
							onNext={goBackHome}
							loadable={false}
							nextButtonText={AppTranslations.alarmsMonitor.texts.close}
						/>
					</VeBoxCard>
				</div>
			</Display>
			<Display isVisible={!isLoadingPage && !errorState}>
				<ProcessPage total={3} className={"flx-col"}>
					<AnimationProvider>
						<NewCensusProcess />
					</AnimationProvider>
				</ProcessPage>
			</Display>
		</>
	);
};
